module.exports = __webpack_public_path__ + "static/img/image18.212146f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image18.png
// module id = JNT5
// module chunks = 1